import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=0e9da718&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=ts"
export * from "./OrderList.vue?vue&type=script&lang=ts"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=0e9da718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9da718",
  null
  
)

export default component.exports